<div class="gov-form-control">
    <div 
        class="gov-multiselect"
        role="combobox"
        aria-haspopup="listbox"
        [attr.aria-owns]="filterItem()!.column + '_listbox'"
        aria-expanded="0"
    >
        <input
            class="gov-form-control__input"
            type="text"
            role="searchbox"
            aria-autocomplete="list"
            [attr.aria-controls]="filterItem()!.column + '_listbox'"
            aria-activedescendant=""
            aria-multiline="0"
            [id]="filterItem()!.column"
            [ngModel]="searchTerm()"
            (ngModelChange)="searchTerm.set($event)"
            (focus)="onInputFocus()">
        <label
            class="gov-form-control__label filterLabel"
            [for]="filterItem()!.column"
        >{{ filterItem()!.label | localize }}</label>
        @if (isOpen() && availableOptions().length > 0) {
            <ul
                role="listbox"
                class="gov-multiselect__options"
                [id]="filterItem()!.column + '_listbox'"
            >
                @for (opt of availableOptions(); track opt.value) {
                    <li
                        class="gov-multiselect__option"
                        role="option"
                        (click)="selectOption(opt)"
                    >{{ opt.text }}</li>
                }
            </ul>
        }
    </div>
    <ul class="gov-multiselect__tags">
        @for (sel of selectedOptions(); track sel.value) {
            <li class="gov-multiselect__tag">
                {{ sel.text }}
                <button
                    class="gov-button--icon-only"
                    type="button"
                    [aria-label]="'grid.obecne.odebrat' | localize"
                    (click)="removeOption(sel.value)"
                ></button>
            </li>
        }
    </ul>
</div>